import styled from '@emotion/styled'
import PropTypes from '~/lib/propTypes'
import SiteSearch from '~/components/SiteSearch'
import { Portal, space, useTransition, device, easing, callAll } from '@ticketswap/solar'
import { useEffect, useState } from 'react'

const duration = 200

const Container = styled.div`
  width: 100%;
`

const Overlay = styled.div`
  position: fixed;
  z-index: 2147483647; /* largest accepted z-index value as integer */
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  padding-block: ${space[16]};
  padding-inline: ${space[16]};

  opacity: ${props => (props.state === 'ENTERING' || props.state === 'ENTERED' ? 1 : 0)};
  transition-duration: ${duration}ms;
  transition-timing-function: ${easing.easeOutCubic};
  transition-property: opacity;

  @media ${device.tablet} {
    display: flex;
    justify-content: center;
    align-items: flex-start;
    padding-block-start: ${space[24]};
  }
`

const SearchOverlay = props => {
  const [on, setOn] = useState(false)
  const hide = () => setOn(false)
  const [state, mounted] = useTransition({
    in: on,
    timeout: duration,
  })

  const toggle = () => {
    setOn(on => !on)
  }

  useEffect(() => {
    const handleEscKeyPress = ({ keyCode }) => keyCode === 27 && hide()

    if (on) {
      document.addEventListener('keydown', handleEscKeyPress, false)
    }

    return () => {
      document.removeEventListener('keydown', handleEscKeyPress, false)
    }
  }, [on])

  const getToggleProps = {
    'aria-controls': 'target',
    'aria-expanded': on,
    onClick: callAll(props.onClick, toggle),
  }

  return (
    <>
      {props.children(getToggleProps)}
      <Portal>
        {mounted && (
          <Overlay aria-modal="true" onClick={hide} tabIndex="-1" state={state}>
            <Container
              onClick={e => e.stopPropagation()}
              onKeyDown={e => e.stopPropagation()}
              role="presentation"
            >
              <SiteSearch
                trigger="searchOverlay"
                width="medium"
                defaultOpen={true}
                onClose={hide}
              />
            </Container>
          </Overlay>
        )}
      </Portal>
    </>
  )
}

SearchOverlay.propTypes = {
  defaultOn: PropTypes.bool,
  on: PropTypes.bool,
  onToggle: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.array]).isRequired,
}

export default SearchOverlay
